import React, { useEffect, useRef } from "react";

const AnimatedLogo = () => {
  const eyeLeftRef = useRef(null);
  const eyeRightRef = useRef(null);

  useEffect(() => {
    const amplitude = 16;
    const moveDuration = 500;
    const pauseDuration = 1000;

    const moveEyes = () => {
      const eyes = [eyeLeftRef.current, eyeRightRef.current];

      eyes.forEach((eye) => {
        if (eye) {
          eye.animate(
            [
              { transform: `translate(0, 0)`, offset: 0 },
              { transform: `translate(-${amplitude}px, 0)`, offset: 0.15 },
              { transform: `translate(-${amplitude}px, 0)`, offset: 0.35 },
              { transform: `translate(0, 0)`, offset: 0.5 },
              { transform: `translate(${amplitude}px, 0)`, offset: 0.65 },
              { transform: `translate(${amplitude}px, 0)`, offset: 0.85 },
              { transform: `translate(0, 0)`, offset: 1 },
            ],
            {
              duration: moveDuration * 4 + pauseDuration * 2,
              easing: "ease-in-out",
              fill: "forwards",
            }
          );
        }
      });
    };

    const interval = setInterval(moveEyes, 7500);

    return () => clearInterval(interval);
  }, []);

  return (
    <svg
      width="91.400383mm"
      height="61.971199mm"
      viewBox="0 0 91.400383 61.971199"
      id="svg1"
      style={{ height: "50px", width: "auto", display: "block" }}
    >
      <defs id="defs1">
        <clipPath id="c60f9dea67">
          <path
            d="m 227.41797,194.76562 h 61.74219 v 56.25 h -61.74219 z m 0,0"
            clipRule="nonzero"
            id="path9"
          />
        </clipPath>
        <clipPath id="6754945111">
          <path
            d="m 258.24609,194.76562 c -17.02734,0 -30.82812,12.59375 -30.82812,28.125 0,15.53516 13.80078,28.125 30.82812,28.125 17.02735,0 30.82813,-12.58984 30.82813,-28.125 0,-15.53125 -13.80078,-28.125 -30.82813,-28.125 z m 0,0"
            clipRule="nonzero"
            id="path10"
          />
        </clipPath>
        <clipPath id="b9c27fe5a2">
          <path
            d="m 0.417969,0.765625 h 61.742187 v 56.25 H 0.417969 Z m 0,0"
            clipRule="nonzero"
            id="path11"
          />
        </clipPath>
        <clipPath id="cf5a830a7e">
          <path
            d="m 31.246094,0.765625 c -17.027344,0 -30.828125,12.59375 -30.828125,28.125 0,15.535156 13.800781,28.125 30.828125,28.125 17.027344,0 30.828125,-12.589844 30.828125,-28.125 0,-15.53125 -13.800781,-28.125 -30.828125,-28.125 z m 0,0"
            clipRule="nonzero"
            id="path12"
          />
        </clipPath>
        <clipPath id="a9f970209b">
          <rect x="0" width="63" y="0" height="58" id="rect12" />
        </clipPath>
        <clipPath id="e13dd5128b">
          <path
            d="m 86.164062,196.67187 h 61.746098 v 56.25 H 86.164062 Z m 0,0"
            clipRule="nonzero"
            id="path13"
          />
        </clipPath>
        <clipPath id="6a1e3e244f">
          <path
            d="m 116.99219,196.67187 c -17.02344,0 -30.828128,12.59375 -30.828128,28.125 0,15.53516 13.804688,28.125 30.828128,28.125 17.02734,0 30.83203,-12.58984 30.83203,-28.125 0,-15.53125 -13.80469,-28.125 -30.83203,-28.125 z m 0,0"
            clipRule="nonzero"
            id="path14"
          />
        </clipPath>
        <clipPath id="0fdd933ba8">
          <path
            d="m 0.164062,0.671875 h 61.675782 v 56.25 H 0.164062 Z m 0,0"
            clipRule="nonzero"
            id="path15"
          />
        </clipPath>
        <clipPath id="39cfd0c1ee">
          <path
            d="m 30.992188,0.671875 c -17.023438,0 -30.828126,12.59375 -30.828126,28.125 0,15.535156 13.804688,28.125 30.828126,28.125 17.027343,0 30.832031,-12.589844 30.832031,-28.125 0,-15.53125 -13.804688,-28.125 -30.832031,-28.125 z m 0,0"
            clipRule="nonzero"
            id="path16"
          />
        </clipPath>
        <clipPath id="ffacaf6405">
          <rect x="0" width="62" y="0" height="57" id="rect16" />
        </clipPath>
      </defs>
      <g id="layer1" transform="translate(-70.783941,-63.650221)">
        <path
          style={{ fill: "#000000" }}
          d="m 148.74585,124.63887 c -0.33759,-0.54039 -1.1251,-1.84789 -1.75001,-2.90554 -1.4132,-2.39182 -0.88926,-2.19835 -5.00265,-1.84724 -20.3095,1.73358 -27.92226,-14.60487 -10.02153,-21.508119 17.37695,-6.70126 36.52415,3.484619 26.79457,14.254109 l -0.89919,0.99529 1.43762,2.44678 c 0.7907,1.34573 1.43762,2.53264 1.43762,2.63756 0,0.22049 -2.90211,1.99965 -3.0365,1.86155 -0.0492,-0.0506 -0.64957,-1.04443 -1.33415,-2.20859 -0.68458,-1.16417 -1.28775,-2.16311 -1.34039,-2.21988 -0.0526,-0.0568 -0.96208,0.30681 -2.02098,0.80794 -1.0589,0.50112 -2.29784,1.08334 -2.75321,1.29383 -0.82794,0.38269 -0.82794,0.38269 0.70316,2.94601 l 1.5311,2.56333 -1.56582,0.93276 -1.56583,0.93276 z m -4.6354,-8.66743 c 9.74363,-1.80093 15.83493,-7.52224 12.47323,-11.7156 -5.72484,-7.141129 -26.12818,-5.011219 -30.56796,3.191 -2.97154,5.48974 7.59126,10.46597 18.09473,8.5246 z m -61.462602,8.15916 -1.497559,-0.90226 1.314619,-2.23359 c 1.221874,-2.07602 1.398704,-2.76238 0.711684,-2.76238 -0.15187,0 -1.292419,-0.47625 -2.534553,-1.05833 -1.242133,-0.58208 -2.293352,-1.05833 -2.336042,-1.05833 -0.04269,0 -0.585679,0.89297 -1.206642,1.98437 -1.310229,2.30286 -1.048637,2.19274 -2.809678,1.18279 -1.677278,-0.96191 -1.669145,-0.8261 -0.198437,-3.3137 1.422076,-2.40534 1.394743,-2.04442 0.255618,-3.37523 -9.68849,-11.31882 11.581325,-21.552719 28.260472,-13.597429 17.0632,8.138459 7.78857,22.886379 -13.049888,20.751099 l -1.9963,-0.20456 -1.533628,2.65129 c -1.850986,3.19994 -1.559453,3.03292 -3.379666,1.93626 z m 17.107976,-8.38736 c 5.571336,-1.24664 8.863326,-4.57226 7.676346,-7.75476 -3.03396,-8.134569 -23.335644,-11.034469 -30.253045,-4.32136 -6.621825,6.42626 9.437328,15.01619 22.576699,12.07612 z M 70.783948,91.767431 c 0,-0.62634 1.409193,-3.46821 2.751891,-5.54964 l 0.938731,-1.45521 0.0068,3.77031 0.0068,3.77032 h -1.852079 c -1.683305,0 -1.852083,-0.0488 -1.852083,-0.53578 z m 9.789584,-6.84042 v -7.37619 l 1.389062,-1.16079 c 0.763985,-0.63843 1.597423,-1.32231 1.852084,-1.51974 0.438909,-0.34027 0.463021,0.1043 0.463021,8.53698 v 8.89594 h -1.852084 -1.852083 z m 9.789584,-3.6002 v -10.9764 l 1.579955,-0.79756 c 0.868975,-0.43866 1.702413,-0.79756 1.852083,-0.79756 0.182372,0 0.272129,3.88341 0.272129,11.77396 v 11.77396 h -1.852084 -1.852083 z m 9.789584,-2.11101 v -13.08741 l 1.65364,-0.4986 c 0.90951,-0.27423 1.74295,-0.45006 1.85209,-0.39073 0.10914,0.0593 0.19844,6.17304 0.19844,13.58601 v 13.47814 h -1.85209 -1.85208 z m 9.78958,-1.03318 v -14.12059 l 0.99219,-0.164 c 2.70454,-0.44704 2.4474,-1.93037 2.4474,14.11768 v 14.2875 h -1.7198 -1.71979 z m 9.78959,-0.16691 c 0,-16.04805 -0.25715,-14.56472 2.44739,-14.11768 l 0.99219,0.164 v 14.12059 14.12059 h -1.71979 -1.71979 z m 9.525,0.79375 c 0,-15.30853 -0.2589,-13.85641 2.33322,-13.08663 l 1.37094,0.40713 v 13.08662 13.08663 h -1.85208 -1.85208 z m 9.78958,1.71979 c 0,-7.89055 0.0898,-11.77396 0.27213,-11.77396 0.14967,0 0.98311,0.3589 1.85208,0.79756 l 1.57996,0.79756 v 10.9764 10.9764 h -1.85209 -1.85208 z m 9.78958,2.87802 c 0,-8.43268 0.0241,-8.87725 0.46303,-8.53698 0.25466,0.19743 1.08809,0.88131 1.85208,1.51974 l 1.38906,1.16079 v 7.37619 7.3762 h -1.85208 -1.85209 z m 9.79636,5.12562 0.007,-3.77031 0.93873,1.45521 c 3.21926,4.99045 3.38117,6.08542 0.89981,6.08542 h -1.85208 z"
          id="path27"
        />

        <g transform="matrix(0.35277778,0,0,0.35277778,50.344981,29.064256)">
          <circle
            ref={eyeRightRef}
            cx="258.246"
            cy="222.891"
            r="27"
            fill="#000000"
          />
          <circle
            ref={eyeLeftRef}
            cx="116.992"
            cy="224.797"
            r="27"
            fill="#000000"
          />
        </g>
      </g>
    </svg>
  );
};

export default AnimatedLogo;
